export type ShareResult = 'shared' | 'copied' | 'failed';

export async function shareStation(stationName: string, description?: string): Promise<ShareResult> {
  const title = 'Suton Radio';
  const text = description
    ? `Slušam ${stationName} - ${description}. Slušaj i ti!`
    : `Slušam ${stationName} na Suton Radio. Zvuk Balkana!`;
  const url = typeof window !== 'undefined' ? window.location.origin : 'https://suton-radio.de';
  const shareText = `${text}\n${url}`;

  // 1. Web Share API (mobilni uređaji, neki desktop preglednici)
  if (typeof navigator !== 'undefined' && navigator.share) {
    try {
      await navigator.share({
        title,
        text,
        url,
      });
      return 'shared';
    } catch (err) {
      if ((err as Error).name === 'AbortError') return 'failed';
      // Nastavi na fallback
    }
  }

  // 2. Clipboard API (zahtijeva HTTPS ili localhost)
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(shareText);
      return 'copied';
    } catch {
      // Nastavi na execCommand fallback
    }
  }

  // 3. execCommand fallback (radi u HTTP, stariji preglednici)
  try {
    const textarea = document.createElement('textarea');
    textarea.value = shareText;
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    textarea.style.top = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok ? 'copied' : 'failed';
  } catch {
    return 'failed';
  }
}
